import styled from 'styled-components';

export const LayoutsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
